import React from 'react';
import cx from 'classnames';
import ReactCodeInput from 'react-code-input';
import styles from './index.module.scss.js';

const CodeInput = ({
  inputMode = "numeric",
  name,
  type = "text",
  disabled = false,
  fields = 6,
  value,
  label,
  error,
  touch = () => {
  },
  untouch = () => {
  },
  onChange = () => {
  },
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    style: {
      ...style,
      "--pin-size": fields
    },
    className: cx(styles.box, className)
  },
  label && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.label, {
        [styles.error]: !!error
      })
    },
    label
  ),
  /* @__PURE__ */ React.createElement(
    ReactCodeInput,
    {
      ...props,
      className: cx(styles.input, className, {
        [styles.error]: !!error
      }),
      name,
      inputMode,
      type,
      disabled,
      fields,
      value,
      touch,
      untouch,
      onChange
    }
  ),
  error && /* @__PURE__ */ React.createElement("div", { className: styles.error }, error.message)
);
CodeInput.displayName = "CodeInput";

export { CodeInput };
//# sourceMappingURL=index.js.map
